__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "infoins-frontend-auth-module";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@infoins-v5/ui", "1.0.37", () => (Promise.all([__webpack_require__.e(362), __webpack_require__.e(475), __webpack_require__.e(8590), __webpack_require__.e(1527), __webpack_require__.e(5929), __webpack_require__.e(3684), __webpack_require__.e(6666), __webpack_require__.e(9222)]).then(() => (() => (__webpack_require__(78590))))));
			register("dayjs", "1.11.21", () => (() => (__webpack_require__(74353))), 1);
			register("framer-motion", "11.18.2", () => (Promise.all([__webpack_require__.e(1955), __webpack_require__.e(1527), __webpack_require__.e(2467)]).then(() => (() => (__webpack_require__(31955))))));
			register("framer-motion", "12.43.0", () => (Promise.all([__webpack_require__.e(6840), __webpack_require__.e(1527), __webpack_require__.e(7095)]).then(() => (() => (__webpack_require__(86840))))));
			register("i18next", "25.10.10", () => (__webpack_require__.e(2635).then(() => (() => (__webpack_require__(72635))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "15.7.4", () => (Promise.all([__webpack_require__.e(2389), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(32389))))));
			register("react-promise-tracker", "2.1.1", () => (Promise.all([__webpack_require__.e(4601), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(54601))))));
			register("react-quill", "2.0.0", () => (Promise.all([__webpack_require__.e(5708), __webpack_require__.e(1527), __webpack_require__.e(5929), __webpack_require__.e(2079)]).then(() => (() => (__webpack_require__(45708))))));
			register("react-redux", "9.3.0", () => (Promise.all([__webpack_require__.e(1468), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(71468))))));
			register("react-router-dom", "7.5.2", () => (Promise.all([__webpack_require__.e(1522), __webpack_require__.e(1527), __webpack_require__.e(5929)]).then(() => (() => (__webpack_require__(81522))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(23722);
			initExternal(53921);
			initExternal(49418);
			initExternal(39698);
			initExternal(21787);
			initExternal(16968);
			initExternal(67184);
			initExternal(56972);
			initExternal(33629);
			initExternal(25917);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};